import {
  type BuyerBidDetailDto,
  type MinimumRequirementDto,
  type BidMinimumRequirementResponseDto,
} from "../../../autogen/bff-api";

export const effectiveMinimumRequirementVerdict = (
  response: BidMinimumRequirementResponseDto | undefined,
): boolean | null => response?.buyerVerdict ?? null;

export interface BidMinimumRequirementProgress {
  fulfilled: number;
  notFulfilled: number;
  pending: number;
  reviewed: number;
  total: number;
  hasRequirements: boolean;
}

const responsesById = (detail: BuyerBidDetailDto) =>
  new Map((detail.bid.minimumRequirementResponses ?? []).map((r) => [r.minimumRequirementId, r] as const));

export const getBidMinimumRequirementProgress = (detail: BuyerBidDetailDto): BidMinimumRequirementProgress => {
  const requirements = detail.minimumRequirements ?? [];
  const byId = responsesById(detail);
  const verdicts = requirements.map((r) => effectiveMinimumRequirementVerdict(byId.get(r.id ?? "")));
  const fulfilled = verdicts.filter((v) => v === true).length;
  const notFulfilled = verdicts.filter((v) => v === false).length;
  const pending = verdicts.length - fulfilled - notFulfilled;
  return {
    fulfilled,
    notFulfilled,
    pending,
    reviewed: fulfilled + notFulfilled,
    total: requirements.length,
    hasRequirements: requirements.length > 0,
  };
};

export interface BidMinimumRequirementRow {
  requirement: MinimumRequirementDto;
  response: BidMinimumRequirementResponseDto | undefined;
}

export const getBidMinimumRequirementRows = (detail: BuyerBidDetailDto): BidMinimumRequirementRow[] => {
  const byId = responsesById(detail);
  return (detail.minimumRequirements ?? []).map((requirement) => ({
    requirement,
    response: byId.get(requirement.id ?? ""),
  }));
};
